import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Button } from '@leanin/ui';
import { ErrorShell } from '@/components/states/ErrorShell';
import { useSession } from '@/lib/use-session';

export const Route = createFileRoute('/not-found')({
  component: NotFound,
});

function NotFound() {
  const { data: session } = useSession();
  const isAuthed = session !== null && session !== undefined;
  const navigate = useNavigate();
  return (
    <ErrorShell
      code="404"
      eyebrow="Page not found"
      title="We can't find that."
      body={
        isAuthed
          ? "The link may be broken, the Circle may be private, or the page may have moved. None of these mean anything is wrong with your account."
          : 'The link may be broken, or the page may have moved.'
      }
      actions={
        isAuthed ? (
          <Button variant="primary" onClick={() => navigate({ to: '/feed' })}>
            Back to your feed
          </Button>
        ) : (
          <>
            <Button variant="primary" onClick={() => navigate({ to: '/auth/login' })}>
              Sign in
            </Button>
            <Button variant="ghost" onClick={() => navigate({ to: '/get-started' })}>
              Create an account
            </Button>
          </>
        )
      }
      isAuthed={isAuthed}
    />
  );
}
